export default __webpack_public_path__ + "static/patio-v4-1-0853c0dafd5189a92449e482a903839b.jpg";